import { jsx as _jsx } from "react/jsx-runtime";
import { Info, Size } from '@transferwise/components';
import { ThemeProvider } from '@wise/components-theming';
import { useIntl } from 'react-intl';
import { FeeType } from '../../domain/Quote';
import componentStyles from './FeeMakeupPopover.module.less';
import NonTransparentFeeElement from './fee-element/NonTransparentFeeElement';
import TransparentFeeElement from './fee-element/TransparentFeeElement';
const FeeMakeupPopover = ({ quote, midmarketRate, isFeaturedRow, onPopoverClick, open, onClose, }) => {
    const content = PopoverContent(quote, midmarketRate, isFeaturedRow);
    // eslint-disable-next-line jest/unbound-method
    const { formatMessage } = useIntl();
    return (_jsx(ThemeProvider, Object.assign({ className: componentStyles.feeMakeupPopover__container, theme: "personal", screenMode: isFeaturedRow ? 'dark' : 'light' }, { children: _jsx(Info, { onClick: onPopoverClick, content: content, size: Size.SMALL, "aria-label": formatMessage({ id: 'what-makes-up-this-fee' }) }) })));
};
export default FeeMakeupPopover;
const PopoverContent = (quote, midmarketRate, isProviderWise) => {
    const hiddenFeesAmount = isProviderWise ? 0 : getFeesSumByType(quote, FeeType.HIDDEN);
    const marketedFeesAmount = getFeesSumByType(quote, FeeType.MARKETED);
    if (hiddenFeesAmount > 0) {
        return (_jsx(NonTransparentFeeElement, { quote: quote, midmarketRate: midmarketRate, marketedFeesAmount: marketedFeesAmount, hiddenFeesAmount: hiddenFeesAmount }));
    }
    else {
        return (_jsx(TransparentFeeElement, { quote: quote, midmarketRate: midmarketRate, marketedFeesAmount: marketedFeesAmount, isProviderWise: isProviderWise }));
    }
};
function getFeesSumByType(quote, feeType) {
    return quote.fees.breakdown
        .filter((fee) => fee.type === feeType)
        .reduce((total, fee) => total + fee.amount.value, 0);
}
